import React from 'react';
import { Quote } from 'lucide-react';

interface TestimonialCardProps {
  quote: string;
  author: string;
  role?: string;
  company?: string;
  avatar?: string;
  className?: string;
}

export const TestimonialCard: React.FC<TestimonialCardProps> = ({
  quote,
  author,
  role,
  company,
  avatar,
  className = '',
}) => {
  return (
    <div className={`
      bg-gradient-to-br from-white/5 to-white/10 backdrop-blur-xl 
      border border-white/10 rounded-2xl p-8 my-8
      hover:from-white/10 hover:to-white/15 hover:border-blue-400/30
      transition-all duration-300 hover:scale-105 hover:shadow-2xl
      ${className}
    `}>
      {/* Quote Icon */}
      <div className="mb-6">
        <div className="w-12 h-12 bg-gradient-to-r from-blue-600/20 to-purple-600/20 rounded-full flex items-center justify-center">
          <Quote className="w-6 h-6 text-blue-400" />
        </div>
      </div>

      {/* Quote Text */}
      <blockquote className="text-white/90 text-lg md:text-xl leading-relaxed mb-6 italic">
        "{quote}"
      </blockquote>

      {/* Author Info */}
      <div className="flex items-center gap-4">
        {avatar ? (
          <img 
            src={avatar} 
            alt={author}
            className="w-12 h-12 rounded-full object-cover border-2 border-white/20"
          />
        ) : (
          <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
            <span className="text-white font-semibold text-lg">
              {author.charAt(0).toUpperCase()}
            </span>
          </div>
        )}
        
        <div>
          <div className="text-white font-semibold">
            {author}
          </div>
          {(role || company) && (
            <div className="text-white/60 text-sm">
              {role && company ? `${role}, ${company}` : role || company}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Container for multiple testimonials
export const TestimonialGrid: React.FC<{ children: React.ReactNode; className?: string }> = ({ 
  children, 
  className = '' 
}) => {
  return (
    <div className={`
      grid grid-cols-1 lg:grid-cols-2 gap-8 my-8
      ${className}
    `}>
      {children}
    </div>
  );
};

export default TestimonialCard;